import { Component, OnInit, Inject, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { JApiService, JCallback, JObject, SysBenutzer } from '@j/api';
import { LanguageService } from '@hio/language';
import { HioDatePipe, InputDirective } from '@hio/share-basic';
import { JcRaisedButtonDirective } from '@jc/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { JcIconButtonDirective } from '@jc/button';
import { ensureShareBasicI18n } from './share-basic-i18n';

@Component({
    selector: 'dialog-objectinfo',
    styles: [
        `

        `
    ],
    template: `
    <h2 mat-dialog-title> {{ lang.t('shareBasic.objectInfoTitle') }}
        <button jcIconButton (click)="onCancel()" tabindex="-1" color="basic" style="float: right;">
            <fa-icon [icon]="['fal', 'times']"></fa-icon>
        </button>
    </h2>
    <hr>

    <mat-dialog-content>
                <mat-form-field class="fw">
                    <mat-label>{{ lang.t('shareBasic.createdBy') }}</mat-label>
          <input matInput type="text" [ngModel]="insertUser()" readonly>
        </mat-form-field>
                <mat-form-field class="fw">
                    <mat-label>{{ lang.t('shareBasic.createdAt') }}</mat-label>
          <input matInput [value]="data.object.dat_ins | hioDate: 'medium'" readonly>
        </mat-form-field>
                <mat-form-field class="fw">
                    <mat-label>{{ lang.t('shareBasic.lastEditedBy') }}</mat-label>
          <input matInput type="text" [ngModel]="updateUser()" readonly>
        </mat-form-field>
                <mat-form-field class="fw">
                    <mat-label>{{ lang.t('shareBasic.editedAt') }}</mat-label>
          <input matInput [value]="data.object.dat_upd | hioDate: 'medium'" readonly>
        </mat-form-field>

    </mat-dialog-content>

    <hr>
    <mat-dialog-actions>
        <div style="flex: 1;"></div>
        <button color="primary" jcRaisedButton (click)="onCancel()">{{ lang.t('shareBasic.close') }}</button>
    </mat-dialog-actions>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogModule, JcIconButtonDirective, FontAwesomeModule, MatFormFieldModule, InputDirective,
            MatInputModule, FormsModule, JcRaisedButtonDirective, HioDatePipe]
})

export class DialogObjectInfoComponent implements OnInit {
    lang = ensureShareBasicI18n(inject(LanguageService));
    /** Signale: objLoad mutiert das Zielobjekt in-place und loest sonst NG0100 aus. */
    public insertUser = signal('');
    public updateUser = signal('');

    constructor(public dialogRef: MatDialogRef<DialogObjectInfoComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { object: JObject, onCancel: Function },
                public api: JApiService) {
        dialogRef.disableClose = false;
    }
    ngOnInit() {
        const insId = this.data.object.user_ins;
        const updId = this.data.object.user_upd;

        if (insId > 1) {
            const user = new SysBenutzer();
            this.api.server.objLoad('/user', insId, user, {}, {}, () => {
                this.insertUser.set(this.displayName(user));
                if (insId == updId)
                    this.updateUser.set(this.displayName(user));
            }, (cb) => {
                if (cb.error == JCallback.nodata) {
                    this.insertUser.set(this.lang.t('shareBasic.unknown'));
                    return false;
                }
            });
        } else {
            this.insertUser.set(this.lang.t('shareBasic.system'));
        }

        if (insId != updId && insId > 1) {
            const user = new SysBenutzer();
            this.api.server.objLoad('/user', updId, user, {}, {}, () => {
                this.updateUser.set(this.displayName(user));
            }, (cb) => {
                if (cb.error == JCallback.nodata) {
                    this.updateUser.set(this.lang.t('shareBasic.unknown'));
                    return false;
                }
            });
        } else if (!(insId > 1)) {
            this.updateUser.set(this.lang.t('shareBasic.system'));
        }
    }
    public onCancel() {
        this.dialogRef.close();
    }

    private displayName(user: SysBenutzer): string {
        return `${user.vorname_mask ?? ''} ${user.nachname_mask ?? ''}`.trim();
    }
}
